module.exports = __webpack_public_path__ + "static/img/icon_2.f37ba9d2.png";